import entries from 'lodash/fp/entries';
import first from 'lodash/fp/first';
import flow from 'lodash/fp/flow';

import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

import { ControlErrorsMessagesOverridesRegistryModel } from './models/control-custom-errors.model';

@Pipe({ name: 'controlErrorText', standalone: true })
export class ControlErrorTextPipe implements PipeTransform {
  public transform(
    errors: ValidationErrors | null,
    errorsMessagesOverridesRegistry: ControlErrorsMessagesOverridesRegistryModel | null | undefined
  ): string {
    const [errorKey, errorContext] = flow(entries, first)(errors);
    return errorsMessagesOverridesRegistry?.[errorKey]?.(errorContext) ?? errorContext?.message ?? '';
  }
}
